<!-- Structure follows widget/kpi-chart's template so the tiles match the app's
     existing KPI cards; the reference design has no header icons. -->
<div class="kpi-card">
  <div class="kpi-header">
    <h3 class="kpi-title" [attr.title]="kpi.title">{{ kpi.title }}</h3>
  </div>

  <div class="kpi-body position-right">
    <div class="metric-section">
      <div class="main-value">
        <span class="value-text" [matTooltip]="kpi.value" matTooltipClass="emd-tip-mat" matTooltipPosition="above">
          {{ kpi.value }}
        </span>
      </div>

      <div class="trend" [ngClass]="trendClass">
        <span class="trend-icon">{{ trendIcon }}</span>
        <span class="trend-value">{{ kpi.change }}</span>
        <span class="trend-label" [attr.title]="kpi.changeLabel">{{ kpi.changeLabel }}</span>
      </div>
    </div>

    <div class="visualization-section">
      <div class="chart-wrapper">
        <div #svgContainer class="chart-container kpi-sparkline-chart"></div>
      </div>
    </div>
  </div>
</div>
